import Microgame from '../engine/Microgame.js';

export default class SwipeGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: 'Swipe !', en: 'Swipe!', es: '¡Desliza!' },
            controls: { fr: 'Glisse ton doigt (ou la souris) dans la direction de la flèche', en: 'Swipe your finger (or mouse) in the direction of the arrow', es: 'Desliza tu dedo en la dirección de la flecha' },
            objective: { fr: 'Fais le bon mouvement le plus vite possible', en: 'Make the correct move as fast as possible', es: 'Haz el movimiento correcto lo más rápido posible' },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20V4"></path><path d="m5 11 7-7 7 7"></path></svg>`,
            actions: [
                { type: 'move', x: 50, y: 60, duration: 300 },
                { type: 'wait', duration: 500 },
                { type: 'swipe', x: 50, y: 60, toX: 50, toY: 25, duration: 400 },
                { type: 'wait', duration: 300 },
                { type: 'move', x: 50, y: 60, duration: 300 },
                { type: 'swipe', x: 50, y: 50, toX: 80, toY: 50, duration: 400 },
                { type: 'wait', duration: 400 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.direction = 'up';
    }

    setup() {
        this.setupNewArrow();
        this.onSwipe = this.onSwipe.bind(this);
        this.engine.input.on('swipe', this.onSwipe);
    }

    onSwipe(data) {
        if (!this.active) return;

        if (data.direction === this.direction) {
            // Check for Time Attack / Infinite Stream mode
            if (this.engine.activeChallenge && this.engine.activeChallenge.config && this.engine.activeChallenge.config.timeAttack) {
                // Increment score and reset
                this.engine.score++;
                this.engine.updateHUD();

                // Visual feedback
                const float = document.createElement('div');
                float.textContent = "+1";
                float.style.position = 'absolute';
                float.style.left = '50%';
                float.style.top = '40%';
                float.style.color = '#fff';
                float.style.fontSize = '2rem';
                float.style.transition = 'all 0.5s';
                this.container.appendChild(float);
                setTimeout(() => {
                    float.style.top = '30%';
                    float.style.opacity = '0';
                    setTimeout(() => float.remove(), 500);
                }, 10);

                // New Direction
                this.setupNewArrow();
            } else {
                this.win();
            }
        } else {
            this.lose();
        }
    }

    setupNewArrow() {
        // Clear old
        const oldArrow = this.container.querySelector('.swipe-arrow');
        if (oldArrow) oldArrow.remove();

        // New Direction
        const directions = ['up', 'down', 'left', 'right'];
        this.direction = directions[Math.floor(Math.random() * directions.length)];
        this.engine.ui.instruction.textContent = `SWIPE ${this.direction.toUpperCase()}!`;

        const arrow = document.createElement('div');
        arrow.className = `swipe-arrow ${this.direction}`;
        arrow.innerHTML = '➜'; // or use an icon

        let arrowColor;
        if (this.direction === 'up' || this.direction === 'down') {
            arrowColor = this.secondaryColor;
        } else {
            arrowColor = this.primaryColor;
        }

        arrow.style.color = arrowColor;
        arrow.style.textShadow = `0 0 20px ${arrowColor}`;
        this.container.appendChild(arrow);
    }

    cleanup() {
        super.cleanup();
    }
}
